<template>
  <section :class="`switch_wrap--${color}`" class="switch_wrap">

    <div
      @click="toggle"
      :class="{ 'active': SwitchIsActive, disable: !isEnable, disabled: disabledAC }"
      class="switch"
      :data-tracking-id="dtmTitle"
      data-tracking-label="onoff"
    >
    
    
       <div class="switch_trigger" :class="{ 'active': SwitchIsActive, disable: !isEnable, miniToggle }">
       <svg :class="miniToggle == true ? 'icon-close' : svg">
          <use :xlink:href="`#${miniToggle == true && !SwitchIsActive ? 'icon-close' : svg}`" />
        </svg>
      </div>
         <ul>
         <template v-if="country === 'germany'">
        <li>An</li>
        <li>Aus</li>
        </template>
        <template v-else>
         <li>on</li>
        <li>off</li>
        </template>
  
      </ul>
    </div>
    <a v-if="lightBoxCopy" class="info-button_popin" @click="togglePopin">
        <svg class="icon-info_small">
          <use xlink:href="#icon-Info_small" />
        </svg>
  </a>
    
    <p class="switch-title">{{title}}</p>
      <lightbox :visible="lightboxVisible" v-on:close="lightboxVisible = false" v-if="lightBoxCopy">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>
<script>
import Lightbox from "@/components/shared/LightBox";
import { mapState } from "vuex";
export default {
	props: {
		active: Boolean,
		title: String,
        miniToggle: Boolean,
        disabledAC: {type: Boolean, default: false, required: false},
		lightBoxCopy: {
			type: Object,
			required: false,
			default: null,
		},
		svg: String,
		color: String,
		dtmTitle: String,
		isEnable: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	data() {
		return {
			SwitchIsActive: this.active,
			lightboxVisible: false,
			MiniToggle: false,
		};
	},
	components: {
		Lightbox,
	},
	computed: {
		...mapState({
			country: (state) => state.country,
		}),
	},
	watch: {
		active: function() {
			this.SwitchIsActive = this.active;
		},
	},
	methods: {
		togglePopin() {
			this.lightboxVisible = !this.lightboxVisible;
		},
		toggle() {
			this.SwitchIsActive = !this.SwitchIsActive;
			// Emit the object list to the parent div
			this.$emit("event_parent", this.SwitchIsActive);
		},
	},
};
</script>
